module.exports = __webpack_public_path__ + "static/media/usn-5.43b2b0b1.jpg";